import { render, staticRenderFns } from "./NotPayment.vue?vue&type=template&id=68543ac4&scoped=true"
import script from "./NotPayment.vue?vue&type=script&lang=js"
export * from "./NotPayment.vue?vue&type=script&lang=js"
import style0 from "./NotPayment.vue?vue&type=style&index=0&id=68543ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68543ac4",
  null
  
)

export default component.exports